<template>
  <div>
    <!-- <b-button class="mb-2" size="sm" :disabled="disabled" variant="primary" @click="getListaSolicitud()">
      <b-icon icon="arrow-clockwise"></b-icon>
      Actualizar
    </b-button> -->

    <b-table ref="table" striped  responsive hover  stacked="md"
      :items="getListaSolicitud"
      @sort-changed="sortChanged"
      :fields="this.fields"
      :current-page="currentPage"
      :busy.sync="isBusy"
      :per-page="perPage"
      :small="true"
      :sort-by.sync="sortBy">
      <template #cell(EstadoSolicitudMedicaString)="row">
      <b-badge variant="primary" class="mr-1">{{ row.value }}</b-badge>
      </template>
      <template #cell(actions)="item">
        <b-form-radio
          v-model="ListaLicenciaCargoPersonalSeleccionado"
          :value="item.item.LicenciaCargoPersonal.Id" name="radio-size" size="lg"> {{ item.item.LicenciaCargoPersonal.Id  }}
        </b-form-radio>
      </template>
      <template #cell(LicenciaCargoPersonal)="row">{{ row.value.Id }} {{ row.value.DisplayCantidadDias }} | desde: {{ row.value.LicenciaDesde | moment('YYYY-MM-DD') }} | hasta: {{ row.value.LicenciaHasta | moment('YYYY-MM-DD') }} | articulo: {{ row.value.DisplayArticulo }} | cie10: {{ row.value.CIE10String  }} | observaciones: {{ row.value.Observaciones }}</template>

      <template slot="table-caption">
      <small><b>Total: </b></small> <b-badge variant="success">{{ this.totalRows }}</b-badge><small> | <b>Ordenado por : </b>{{ sortBy }}</small>

      </template>
    </b-table>

    <b-row>
      <b-col md="6">
        <b-pagination @input="getListaSolicitud()" size="sm"
          :total-rows="this.totalRows"
          :per-page="perPage"
          v-model="currentPage" />
      </b-col>
      <b-col md="6">
        <b-form-group breakpoint="sm" class="mb-3">
          <b-form-select size="sm" :options="pageOptions" v-model="perPage"/>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { createHelpers } from 'vuex-map-fields';
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import Solicitudsvc from '@/services/solicitudes'
const { mapFields: mapFormSolicitudAltaFields } = createHelpers({
  getterType: 'FormSolicitudAltaModule/getSolicitudAltaField',
  mutationType: 'FormSolicitudAltaModule/updateSolicitudAltaField',
});
export default {
  mixins: [errorhandler, swalerts],
  name: "TablaHistorialSolicitudMedica",
  computed: {
    ...mapFormSolicitudAltaFields(['ListaLicenciaCargoPersonalSeleccionado']),
    ...mapGetters(['getEstablecimiento']),
  },
  props: {
    seleccionable: Boolean,
    personal: Object
  },
  watch: {
    'getEstablecimiento': function (newvalue, oldvalue) {
      console.log('refresh table newvalue oldvalue', newvalue, oldvalue);
      this.$refs.table.refresh();
    }
  },
  data() {
    return {
      disabled: false,
      isBusy: false,
      lista: [],
      sortBy: 'Id',
      sortOrder: 'desc',
      totalRows:null,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      fields: [
        {
          key: 'actions',
          label: 'Id',
          sortable: true
        },
        // {
        //   key: 'Id',
        //   label: 'Id',
        //   sortable: true,
        //   class: 'text-center',
        //   thStyle: {
        //       maxWidth: '80px',
        //       minWidth: '80px'
        //   }
        // },
        {
          key: 'LicenciaCargoPersonal',
          label: 'Licencia',
        },
        {
          key: 'EstadoSolicitudMedicaString',
          label: 'Estado',
        },
        // {
        //   key: 'acciones',
        //   label: 'Acciones',
        // },
      ]
    }
  },
  methods: {
    sortChanged: function(e){
      console.log('sortChanged', e);
      this.sortOrder = e.sortDesc ? 'desc' : 'asc';
    },
    getListaSolicitud: function ()
    {
      console.log('getListaSolicitud', this.currentPage, this.perPage, this.personal.Id);

      let promise = Solicitudsvc.getLista({
        sort: 3,
        order: this.sortOrder,
        offset:(this.currentPage-1) * this.perPage,
        limit: this.perPage,
        personal_id: this.personal.Id,
        TipoSolicitudLicencia: 0,
        IncluyeLicenciaCargoPersonal: true
      });
      return promise.then(r => {
        console.log("getListaSolicitud then", r);
        this.totalRows = r.data.total;

        let filteredRows = r.data.rows.filter(row => row.LicenciaCargoPersonalString !== 'NULL');
        return filteredRows;
      }).catch(error=>{

        this.disabled = false;
        console.log("Error en getListaSolicitud", error);
        this.errorHandler(e);
      })
    },
  }

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/TablaHistorialSolicitudMedica.vue